import React from 'react';
import styled from 'styled-components';
import BSGLOGO from '../../assets/icons/BSG.png';
import NewFooter from '../../components/Footer/NewFooter';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const HeaderContainer = styled.header`
  background-color: #53a8a0;
  display: flex;
  align-items: center;
  display: flex;
  height: 80px;
  @media (max-width: 767px) {
    flex-direction: column;
    height: auto;
    padding: 10px;
  }
`;
const Logo = styled.img`
  width: 50px;
  height: 50px;
`;
const LogoContainer = styled.div`
  width: 12%;
  display: flex;
  align-items: center;
  justify-content: center;
  @media (max-width: 767px) {
    align-items: flex-start;
    justify-content: flex-start;
    width: -webkit-fill-available;
  }
`;

const Container = styled.div`
  width: 100%;
  margin: 0 auto;
  background: #e9e9e9;
`;

const ContainerIn = styled.div`
  width: 80%;
  padding: 30px;
  margin: 0 auto;
  background: #fff;
  box-sizing: border-box;
  @media (max-width: 767px) {
    width: 90%;
  }
`;

const AboutHeading = styled.h2`
  text-align: center;
  margin-top: 40px;
  font-size: 29px;
  font-family: sans-serif;
`;

const ParagraphContent = styled.p`
  font-size: 16px;
  line-height: 25px;
`;

const AboutBSG = () => {
  const navigate = useNavigate();
  const TITLE = 'About BSG - BSG Contribution Site';
  return (
    <>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>
      <HeaderContainer>
        <LogoContainer onClick={() => navigate('/login')}>
          <Logo src={BSGLOGO} alt="Logo" />
        </LogoContainer>
      </HeaderContainer>
      <Container>
        <ContainerIn>
          <AboutHeading>About BSG</AboutHeading>
          <div />
          <ParagraphContent>
            Bharat Soka Gakkai (BSG) is the Indian affiliate of the Soka Gakkai
            International (SGI), a global association of grassroots
            organisations that seeks to promote the values of peace and respect
            for all people. With its headquarters in New Delhi, BSG has its
            membership spread over 300 towns and cities across India. Coming
            from all walks of life, the members of BSG are engaged in their
            ‘human revolution’, drawing inspiration from the humanistic life
            philosophy. Central to this philosophy is the belief that a
            fundamental change in a single individual can bring about a great
            transformation in society.
          </ParagraphContent>
          <ParagraphContent>
            SGI, with over 12 million members in 192 countries and territories
            around the world has at the core of its movement for peace, the
            ideal of education for global citizenship. Through a wide range of
            activities, the SGI seeks to foster awareness of the social and
            environmental responsibilities we all share for the future of our
            planet. This is education in the broadest sense of the word, and it
            is not limited to classrooms or to any particular age group. Through
            cultural exchange and direct interactions with people, SGI
            organisations seek to advance the search for common values such as
            tolerance and coexistence despite differences and to strengthen our
            sense of common humanity. Working in consonance with the guiding
            principles of the SGI, BSG has sought to create an environment of
            peace through cultural, educational and community-related
            activities. What sets these initiatives apart is the humanistic
            spirit of ‘reaching out’ through ‘heart-to-heart’ dialogue, as
            practised by the founding president of SGI, Dr Daisaku Ikeda.
          </ParagraphContent>
          <ParagraphContent>
            The prime point of BSG’s growth has been the visits of SGI President
            Ikeda to India in the last five decades. During his visit in 1961
            President Ikeda visited Bodh Gaya, and in 1979 he met and encouraged
            a handful of BSG members. His visits in 1992 and 1997 were on the
            invitation of various Indian organisations like Indian Council for
            Cultural Relations (ICCR), etc., where he met top government leaders
            and bureaucrats and delivered lectures. At the invitation of Gandhi
            Samriti and Darshan Samiti in 1992, President Ikeda delivered a
            lecture titled “Towards a World without War – Gandhism and the
            Modern World”. In 1997, he gave a lecture titled “A New Humanism for
            the Coming Century” at the invitation of Rajiv Gandhi Institute of
            Contemporary Studies. Through these meetings and lectures, President
            Ikeda created a deep understanding of the Soka Gakkai movement in
            Indian society. These visits became the catalyst for the heightened
            awareness of BSG members to strive as contributive citizens of the
            country.
          </ParagraphContent>
        </ContainerIn>
      </Container>
      <NewFooter />
    </>
  );
};

export default AboutBSG;
